import { createFileRoute } from '@tanstack/react-router'
import { CommunicationsInboxPage } from '@/pages/communications/communications-inbox-page'

export const Route = createFileRoute('/communications/contacts')({
  validateSearch: validateConversationSearch,
  component: CommunicationsInboxPage,
})

export function validateConversationSearch(search: Record<string, unknown>): {
  conversationId?: string
  workspaceId?: string
  notifications?: boolean
} {
  return {
    workspaceId:
      typeof search.workspaceId === 'string' ? search.workspaceId : undefined,
    notifications:
      search.notifications === true ||
      search.notifications === 'true' ||
      undefined,
    conversationId:
      typeof search.conversationId === 'string' &&
      search.conversationId.trim().length > 0
        ? search.conversationId
        : undefined,
  }
}
